module.exports = __webpack_public_path__ + "src/images/measurements/waistCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/waistCircumference.jpg
// module id = 1161
// module chunks = 0